// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1VXol","contacts_section_container":"styles_contacts_section_container__1VAD-"};